import { useRecoilValue } from 'recoil'
import eventsSelectors from 'screens/Admin/Events/events.selectors'
import selfProjectsAtom from 'screens/Auth/components/InitProvider/selfProjects.atom'
import projectsUtils from '../projects.utils'

const useSelfActiveProject = () => {
  const eventsMap = useRecoilValue(eventsSelectors.eventsFullMap)
  const selfProjects = useRecoilValue(selfProjectsAtom)

  return selfProjects.items.find((it) => projectsUtils.isActiveProject(it, eventsMap))
}

export default useSelfActiveProject
